export const RESET = 'INCOTERM_UPDATE_RESET'
export const SET_ERROR = 'INCOTERM_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'INCOTERM_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'INCOTERM_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'INCOTERM_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'INCOTERM_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'INCOTERM_UPDATE_UPDATE_RETRIEVED'
export const SET_FILES = 'INCOTERM_UPDATE_FILES'



// WEBPACK FOOTER //
// ./src/store/modules/incoterm/update/mutation_types.js